<template>
  <responsive-drawer-layout v-if="isLoaded" :isContentPdf="displayedDocumentUrl !== null" :hasDrawer="false" contentUrl="pdfJsDocumentUrl">
    <!-- Page content -->
    <template v-slot:content>
      <!-- Document display -->
      <transition v-if="isLoaded && displayedDocumentUrl" name="fade">
        <div class="mx-0 fahrdienstPdfContainer inherit-height">
          <pdf-js v-if="displayedDocumentUrl" :url="displayedDocumentUrl" :download-file-name="downloadFileName"></pdf-js>
        </div>
      </transition>

      <!-- loading display -->
      <info-card v-if="!isLoaded" :textRows="[$t('isLoading.moduleIsGettingLoaded')]">
        <template v-slot:title>{{ $t('isLoading.title') }}</template>
      </info-card>

      <info-card v-if="isLoaded && displayMode === 'tour'">
        <template v-slot:title>{{ $t('fahrdienst452.noSelectedTrack.title') }}</template>
        <template v-slot:content>
          <div>{{ $t('fahrdienst452.noSelectedTrack') }}</div>
        </template>
      </info-card>
    </template>
  </responsive-drawer-layout>
</template>

<script>
import { mapState } from 'vuex';
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import dateTimeMixin from '@/mixins/dateTimeMixin';
import ResponsiveDrawerLayout from '@/layouts/ResponsiveDrawerLayout';
import PdfJs from '@/components/pdf/PdfJs';
import InfoCard from '@/components/container/InfoCard';
import index from './index';

export default {
  name: 'Fahrdienst',
  mixins: [common, configMixin, dateTimeMixin],

  components: {
    ResponsiveDrawerLayout,
    PdfJs,
    InfoCard,
  },
  created() {
    this.init();
  },

  computed: {
    ...mapState('fahrplan', ['isLoaded', 'fahrdienstTypes', 'fahrplanFilesById', 'files', 'displayMode', 'unreadCount']),
    instance() {
      return Number(this.$route.params.instance);
    },

    moduleConfig() {
      return this.getModuleConfig(index.moduleType);
    },

    displayedDocument() {
      return this.$route.params.documentId ? this.fahrplanFilesById[this.$route.params.documentId] : null;
    },
    displayedDocumentUrl() {
      return this.constructPdfJsFileUrl(index.api, this.displayedDocument, 'filename');
    },
    downloadFileName() {
      const selectedDoc = this.fahrplanFilesById[this.$route.params.documentId];
      if (!selectedDoc) return '';

      const { filename, title } = selectedDoc;

      const extension = filename.split('.')[1];

      if (!extension) return '';

      return `${title}.${extension}`;
    },
  },
  methods: {
    init() {
      if (!this.isLoaded) return;
      let { instance, dutyId, dateYYYYMMDD, documentId } = this.$route.params;
      // Choose today in case no duty / date has been chosen
      let file = this.fahrplanFilesById[documentId];
    },
  },
  watch: {
    $route(newValue, oldValue) {
      if (newValue !== oldValue) this.init();
    },
    isLoaded() {
      this.init();
    },
  },
};
</script>
